/*
 *	MagmaRp
 *	- Gestion des forms (import/export, édition/affichage, données)
 *	- Gestion des scripts (règles, collisions, événements)
 *	- Gestion des générateurs (maps, perso, loots, histoire [dwarf fortress])
 *	- Gestion des médias (images, sons, tilesets)
 *	- Gestion multi (chat intelligent, diffusion, temps réel)
 *	- Gestion des cartes (sprites, textures, géométries, positions)
 *	- Gestion des events (clavier, souris)
 */
import Magma from './Magma';
import Tileset from './Tileset';
import Map from './Map';
import Project from './Project';

Magma.Tileset = Tileset;
Magma.Map = Map;
Magma.Project = Project;

export default Magma;
